import { pathConstants } from '../../Utils/Constants';

import { PortalTextSettings } from '../../Models/Api/strongbox.financialportal';

export enum SettingsTabId {
    userManagement = 'userManagement',
    notificationSettings = 'notificationSettings',
    notificationAdminSettings = 'notificationAdminSettings',
}

export type SettingsTab = {
    tabId: SettingsTabId;
    path: string;
}

export const settingsTabs: SettingsTab[] = [
    {
        tabId: SettingsTabId.userManagement,
        path: pathConstants.settingsUserManagement,
    }
];

export function GetSettingTabLabel(id: SettingsTabId, settingsText?: PortalTextSettings): string {
    switch (id) {
        case SettingsTabId.userManagement:
            return settingsText?.userManagementTab || '';
        case SettingsTabId.notificationSettings:
            return settingsText?.myNotificationSettingsTab || '';
        case SettingsTabId.notificationAdminSettings:
            return settingsText?.administrativeSettingsTab || '';
    }
    return '';
}
